module.exports = __webpack_public_path__ + "img/mahjongLegacy.b19a8e47.jpeg";